<!-- CellContentPopover.vue -->
<!-- 
  セルの内容を詳細表示するポップオーバーコンポーネント
  マウスホバー時に表示され、セルの内容を読みやすく表示します。
  閉じるボタン付きで、ホバーイベントと手動での閉じる操作に対応します。
-->
<template>
  <div 
    v-if="showPopover" 
    class="cell-popover-overlay" 
    :style="popoverStyle"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @wheel.stop
  >
    <!-- ポップオーバーの本体コンテンツ -->
    <div class="cell-popover-content">
      <!-- 選択可能なテキストコンテンツ -->
      <div class="content-text selectable">
        {{ text }}
      </div>
    </div>
    <!-- 閉じるボタン -->
    <button @click="$emit('close')" class="close-button" aria-label="閉じる">
      <i class="mdi mdi-close"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CellContentPopover',
  props: {
    // 表示するテキストコンテンツ
    text: {
      type: String,
      required: true
    },
    // ポップオーバーの位置やスタイルを制御するためのスタイルオブジェクト
    popoverStyle: {
      type: Object,
      default: () => ({})
    }
  },
  // 発行するイベント：マウスの入退出と閉じる操作
  emits: ['mouseenter', 'mouseleave', 'close'],
  
  data() {
    return {
      showPopover: true,    // ポップオーバーの表示状態
      isHovered: false      // ホバー状態の管理
    }
  },
  
  methods: {
    // マウスが入ってきた時のイベントハンドラ
    handleMouseEnter(event) {
      this.isHovered = true;
      this.$emit('mouseenter', { isPopoverHovered: true });
    },
    // マウスが出た時のイベントハンドラ
    handleMouseLeave(event) {
      this.isHovered = false;
      this.$emit('mouseleave', { isPopoverHovered: false });
    }
  }
}
</script>

<style lang="scss" scoped>
// 共通のスタイル変数
$primary-color: #a00;         // プライマリカラー（赤系）
$hover-color: #ff4081;        // ホバー時のカラー（ピンク系）
$background-color: #ffffff;    // 背景色
$border-radius: 8px;          // 角丸の大きさ
$box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);  // シャドウ効果
$transition-duration: 0.2s;    // アニメーション時間

/* ポップオーバーの基本コンテナ */
.cell-popover-overlay {
  position: fixed;
  background: $background-color;
  border: 1px solid rgba($primary-color, 0.2);
  border-radius: $border-radius;
  padding: 16px;
  box-shadow: $box-shadow;
  min-width: 200px;          // 最小幅
  max-width: 300px;          // 最大幅（長いテキストの折り返し制御）
  z-index: 1000;             // 他の要素より前面に表示
  backdrop-filter: blur(8px); // 背景のブラー効果
  transition: all $transition-duration ease;

  // ホバー時の浮き上がり効果
  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }
}

/* スクロール可能なコンテンツエリア */
.cell-popover-content {
  max-height: 300px;        // 最大高さ（スクロール制御用）
  overflow-y: auto;         // 縦方向のスクロールを有効化
  scrollbar-width: thin;    // Firefoxのスクロールバー幅
  scrollbar-color: $primary-color rgba($primary-color, 0.1);  // Firefoxのスクロールバー色
}

/* テキストコンテンツのスタイル */
.content-text {
  white-space: pre-wrap;    // 改行とスペースを保持
  word-break: break-word;   // 長い単語の折り返し
  text-align: left;         // 左揃え
  user-select: text;        // テキスト選択を有効化
  cursor: text;             // テキスト選択カーソル
  color: #333;              // テキスト色
  line-height: 1.5;         // 行間
  font-size: 14px;          // フォントサイズ
}

/* Webkit系ブラウザ用のスクロールバーカスタマイズ */
.cell-popover-content::-webkit-scrollbar {
  width: 4px;
}

.cell-popover-content::-webkit-scrollbar-track {
  background: rgba($primary-color, 0.1);
  border-radius: 2px;
}

.cell-popover-content::-webkit-scrollbar-thumb {
  background: $primary-color;
  border-radius: 2px;
  
  &:hover {
    background: $hover-color;
  }
}

/* 閉じるボタンのスタイル */
.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  color: #666;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all $transition-duration ease;

  // ホバー時のスタイル
  &:hover {
    background: rgba($primary-color, 0.1);
    color: $primary-color;
  }

  i {
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components2/Manage/modal/CellContentPopover.vue